import { useCallback, useEffect, useState } from "react";

import { getNonprofitPricingCalculatorData, PlansByProduct } from "./client.ts";

export const useNonProfitPricingCalculatorData = () => {
    const [plansDataByProduct, setPlansDataByProduct] =
        useState<PlansByProduct>();
    const [error, setError] = useState<unknown>();

    const loadPricingCalculatorData = useCallback(async () => {
        try {
            const result = await getNonprofitPricingCalculatorData();
            setPlansDataByProduct(result);
        } catch (err) {
            setError(err);
        }
    }, []);

    useEffect(() => {
        void loadPricingCalculatorData();
    }, [loadPricingCalculatorData]);

    return {
        plansDataByProduct,
        error
    };
};
